import React, { useEffect, useState, lazy, createElement } from 'react';
import { CheckIcon } from 'lucide-react';
export function App() {
  const [secondsLeft, setSecondsLeft] = useState(600);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const id = setInterval(() => {
      setSecondsLeft(s => s <= 1 ? 0 : s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);
  // Load and mount the Hotmart Sales Funnel widget (handles yes/no using purchase data)
  useEffect(() => {
    const SCRIPT_SRC = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    const mountFunnel = () => {
      const el = (window as any).checkoutElements;
      if (el && typeof el.init === 'function') {
        try {
          el.init('salesFunnel').mount('#hotmart-sales-funnel');
        } catch {
          /* widget already mounted or unavailable */
        }
      }
    };
    let script = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`);
    if (script && (window as any).checkoutElements) {
      mountFunnel();
      return;
    }
    if (!script) {
      script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
    script.addEventListener('load', mountFunnel);
    return () => {
      script?.removeEventListener('load', mountFunnel);
    };
  }, []);
  const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');
  const expired = secondsLeft <= 0;
  const benefits = ['La técnica completa con guía profesional de la DOC', 'Los movimientos y contracciones del suelo pélvico', 'Cómo intensificar su placer de formas que él no anticipa', 'El entrenamiento para tener el control real de tu cuerpo'];
  return <main className="w-full min-h-full flex justify-center" style={{
    backgroundColor: '#0a0a0a',
    color: '#ffffff'
  }} data-id="element-0">
      <div className="relative w-full overflow-hidden" style={{
      maxWidth: 480
    }} data-id="element-1">
        {/* Background decorative glow shapes */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-2">
          <div className="absolute rounded-full" style={{
          top: -120,
          right: -120,
          width: 320,
          height: 320,
          background: 'radial-gradient(circle, rgba(124,58,237,0.35) 0%, rgba(124,58,237,0) 70%)',
          filter: 'blur(20px)'
        }} data-id="element-3" />
          <div className="absolute rounded-full" style={{
          top: 520,
          left: -160,
          width: 360,
          height: 360,
          background: 'radial-gradient(circle, rgba(124,58,237,0.25) 0%, rgba(124,58,237,0) 70%)',
          filter: 'blur(20px)'
        }} data-id="element-4" />
          <div className="absolute rounded-full" style={{
          bottom: -140,
          right: -100,
          width: 340,
          height: 340,
          background: 'radial-gradient(circle, rgba(124,58,237,0.3) 0%, rgba(124,58,237,0) 70%)',
          filter: 'blur(20px)'
        }} data-id="element-5" />
        </div>

        {/* Content */}
        <div className="relative" data-id="element-6">
          {/* 1. URGENCY BAR */}
          <div className="w-full text-center font-bold uppercase" style={{
          backgroundColor: '#7c3aed',
          color: '#ffffff',
          fontSize: 13,
          letterSpacing: '0.1em',
          padding: '12px 16px'
        }} data-id="element-7">
            Última oferta — Solo disponible en este instante
          </div>

          <div className="px-5 pb-12" data-id="element-8">
            {/* 2. PROGRESS INDICATOR */}
            <section className="pt-8" aria-label="Tu progreso" data-id="element-9">
              <p className="text-center mb-5" style={{
              fontSize: 12,
              color: '#9ca3af'
            }} data-id="element-10">
                Tu experiencia de hoy:
              </p>
              <div className="flex items-start justify-between px-2" data-id="element-11">
                <ProgressStep label="Kamasutra" state="done" data-id="element-12" />
                <Connector done data-id="element-13" />
                <ProgressStep label="FELAR" state="done" data-id="element-14" />
                <Connector done={false} data-id="element-15" />
                <ProgressStep label="Cabalgata" state="current" data-id="element-16" />
              </div>
            </section>

            {/* 3. COUNTDOWN TIMER */}
            <section className="mt-10" aria-label="Cuenta regresiva" data-id="element-17">
              <p className="text-center mb-3" style={{
              fontSize: 12,
              color: '#9ca3af'
            }} data-id="element-18">
                Esta oferta desaparece en:
              </p>
              <div className="mx-auto rounded-2xl text-center" style={{
              backgroundColor: '#1a1a1a',
              padding: 24
            }} data-id="element-19">
                {expired ? <p style={{
                color: '#ef4444',
                fontSize: 20,
                fontWeight: 700
              }} data-id="element-20">
                    Esta oferta ha expirado.
                  </p> : <div className="flex items-start justify-center gap-6" data-id="element-21">
                    <TimeUnit value={minutes} label="MINUTOS" data-id="element-22" />
                    <span style={{
                  color: '#7c3aed',
                  fontSize: 48,
                  fontWeight: 800,
                  lineHeight: 1
                }} data-id="element-23">
                      :
                    </span>
                    <TimeUnit value={seconds} label="SEGUNDOS" data-id="element-24" />
                  </div>}
              </div>
            </section>

            {/* 4. HEADLINE */}
            <h1 className="text-center mt-10" style={{
            fontSize: 32,
            fontWeight: 700,
            lineHeight: 1.2
          }} data-id="element-25">
              Ya tienes dos herramientas. Esta es la que pone todo el control en
              tus manos.
            </h1>

            {/* 5. SUBHEADLINE */}
            <p className="text-center mt-4" style={{
            fontSize: 18,
            color: '#9ca3af',
            lineHeight: 1.4
          }} data-id="element-26">
              Cabalgata Virgen no está disponible en ningún otro lugar a este
              precio. Solo aquí. Solo ahora.
            </p>

            {/* 6. CONTEXT BLOCK */}
            <div className="mt-8 rounded-xl" style={{
            backgroundColor: '#1a1a1a',
            borderLeft: '3px solid #7c3aed',
            padding: 16
          }} data-id="element-27">
              <p style={{
              fontSize: 16,
              color: '#9ca3af',
              lineHeight: 1.7
            }} data-id="element-28">
                Acabas de agregar Kamasutra para enamorar y FELAR a tu
                experiencia. Beatriz tiene una última clase para completar lo
                que empezaste hoy.
              </p>
            </div>

            {/* Imagen — SOS (refuerza la urgencia / "última clase") */}
            <img src="https://cdn.magicpatterns.com/uploads/gwjFss8m2Rg1inLMuNgy33/Imagen_3_cabalgata.jpg" alt="Una mujer sosteniendo un cartel que dice SOS" className="mt-6 w-full rounded-xl object-cover" loading="lazy" data-id="element-29" />

            {/* 7. PRODUCT SECTION */}
            <section className="mt-10 text-center" data-id="element-30">
              {/* Imagen — Portada de marca Cabalgata Virgen */}
              <img src="https://cdn.magicpatterns.com/uploads/n1M99STzqkPci7Yx87o9Lu/Imagen_1_Cabalgata.jpg" alt="Cabalgata Virgen — La DOC y sin censura" className="mb-6 w-full rounded-xl object-cover" loading="lazy" data-id="element-31" />
              <h2 style={{
              fontSize: 48,
              fontWeight: 700,
              lineHeight: 1.1
            }} data-id="element-32">
                CABALGATA VIRGEN
              </h2>
              <p className="mt-3" style={{
              fontSize: 16,
              color: '#9ca3af',
              lineHeight: 1.6
            }} data-id="element-33">
                No es una posición. Es maestría. Es tener el control total
                mientras él pierde el suyo.
              </p>
            </section>

            {/* 8. BENEFITS LIST */}
            <ul className="mt-8 space-y-2" data-id="element-34">
              {benefits.map(b => <li key={b} className="flex items-start" style={{
              gap: 8,
              lineHeight: 2
            }} data-id="element-35">
                  <CheckIcon size={20} strokeWidth={3} style={{
                color: '#7c3aed',
                flexShrink: 0,
                marginTop: 6
              }} aria-hidden="true" data-id="element-36" />
                  <span style={{
                fontSize: 16
              }} data-id="element-37">
                    {b}
                  </span>
                </li>)}
            </ul>

            {/* Imagen — El resultado: control total en la intimidad */}
            <img src="https://cdn.magicpatterns.com/uploads/j66kqek5a5gBr1e3q2mzo3/Imagen_2_cabalgata.jpg" alt="Pareja en la intimidad disfrutando del momento" className="mt-8 w-full rounded-xl object-cover" loading="lazy" data-id="element-38" />

            {/* 9. PRICE BLOCK */}
            <div className="mt-10 rounded-2xl text-center" style={{
            backgroundColor: '#1a1a1a',
            padding: 32
          }} data-id="element-39">
              <span className="inline-block rounded-full font-semibold" style={{
              backgroundColor: '#7c3aed',
              color: '#ffffff',
              fontSize: 12,
              padding: '6px 14px'
            }} data-id="element-40">
                AHORRAS 54%
              </span>
              <p className="mt-4" style={{
              fontSize: 20,
              color: '#6b7280',
              textDecoration: 'line-through'
            }} data-id="element-41">
                Valor regular: $37
              </p>
              <p style={{
              fontSize: 56,
              fontWeight: 800,
              color: '#7c3aed',
              lineHeight: 1.1
            }} data-id="element-42">
                $16.97
              </p>
              <p className="mt-3" style={{
              fontSize: 14,
              color: '#9ca3af'
            }} data-id="element-43">
                Un clic más. Sin datos. Sin esperas.
              </p>
            </div>

            {/* 10. HOTMART SALES FUNNEL WIDGET (yes/no using purchase data) */}
            <div className="mt-6" data-id="element-44">
              <div id="hotmart-sales-funnel" data-id="element-45"></div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}
function ProgressStep({
  label,
  state
}: {
  label: string;
  state: 'done' | 'current';
}) {
  const done = state === 'done';
  return <div className="flex flex-col items-center" style={{
    width: 80
  }} data-id="element-46">
      <div className="flex items-center justify-center rounded-full" style={{
      width: 32,
      height: 32,
      backgroundColor: done ? '#7c3aed' : 'transparent',
      border: done ? 'none' : '2px solid #7c3aed',
      animation: done ? 'none' : 'oto-pulse 1.5s ease-in-out infinite'
    }} data-id="element-47">
        {done ? <CheckIcon size={18} strokeWidth={3} style={{
        color: '#ffffff'
      }} aria-hidden="true" data-id="element-48" /> : null}
      </div>
      <span className="text-center mt-2" style={{
      fontSize: 12,
      color: done ? '#ffffff' : '#7c3aed'
    }} data-id="element-49">
        {label} {done ? '✓' : '←'}
      </span>
      <style data-id="element-50">{`
        @keyframes oto-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(124,58,237,0.5); }
          50% { box-shadow: 0 0 0 8px rgba(124,58,237,0); }
        }
      `}</style>
    </div>;
}
function Connector({
  done
}: {
  done: boolean;
}) {
  return <div className="flex-1 rounded-full" style={{
    height: 3,
    marginTop: 14,
    backgroundColor: done ? '#7c3aed' : '#374151'
  }} data-id="element-51" />;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-52">
      <span style={{
      color: '#7c3aed',
      fontSize: 48,
      fontWeight: 800,
      lineHeight: 1
    }} data-id="element-53">
        {value}
      </span>
      <span className="mt-1" style={{
      color: '#ffffff',
      fontSize: 12,
      letterSpacing: '0.05em'
    }} data-id="element-54">
        {label}
      </span>
    </div>;
}